import React from 'react';

// tslint:disable: max-line-length
interface Props {
  width?: number;
  className?: string;
}
export default function Check(props: Props) {
  return (
    <svg
      width={props.width ? props.width + 'px' : '17px'}
      className={props.className && props.className}
      height="13px"
      viewBox="0 0 17 13"
      version="1.1"
    >
      <title>Valide</title>
      <g id="BOARD-3---Icônes" transform="translate(-974.000000, -592.000000)" fill="#1B202D">
        <g id="Pictogrammes" transform="translate(305.000000, 178.000000)">
          <g id="27---Valider" transform="translate(669.000000, 407.000000)">
            <path
              d="M16.554416,7.35476821 C16.000869,6.84846485 15.139994,6.8881438 14.6341133,7.44778947 L6.33804095,16.6392277 L2.330089,12.5395989 C1.80102672,12.0004483 0.941523419,11.9922365 0.407042951,12.5231753 C-0.12880921,13.052734 -0.136970788,13.9189081 0.390719795,14.4580588 L5.40775825,19.5894782 C5.66481366,19.8521873 6.01294953,19.9986199 6.37740856,19.9986199 C6.38557014,19.9986199 6.39510341,19.9986199 6.40326499,20 C6.77862898,19.9917882 7.13225163,19.8303121 7.38382026,19.5511794 L16.6467995,9.28834054 C17.1514457,8.72724573 17.1106378,7.86245171 16.554416,7.35476821 Z"
              id="Path"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}
